import { render, staticRenderFns } from "./StructBl.vue?vue&type=template&id=2c0be2ba&scoped=true&"
import script from "./StructBl.vue?vue&type=script&lang=js&"
export * from "./StructBl.vue?vue&type=script&lang=js&"
import style0 from "./StructBl.vue?vue&type=style&index=0&id=2c0be2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0be2ba",
  null
  
)

/* custom blocks */
import block0 from "./StructBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports